const actionTypes = {
  ADD_NOTIFY: 'notify/ADD_NOTIFY',
  DELETE_NOTIFY: 'notify/DELETE_NOTIFY',
};

function addNotify(text, coef, text2, amount, type = 'default', closeTime = 2000, needClose = true) {
  return async dispatch => {
    const id = new Date().toISOString();
    const notifycation = { text, coef, text2, amount, type, id, needClose, closeTime };
    dispatch({ type: actionTypes.ADD_NOTIFY, payload: notifycation });
  };
}

function deleteNotify(id) {
  return async dispatch => {
    dispatch({ type: actionTypes.DELETE_NOTIFY, payload: id });
  };
}

export {
  actionTypes,
  addNotify,
  deleteNotify,
};
